import React from 'react';
import { createFileRoute, Outlet, redirect, useRouter } from '@tanstack/react-router';
import { useAuthenticationState } from '@/hooks/use-authentication';
import { useTheme } from '@/providers/theme-provider';
export const Route = createFileRoute('/console/_authenticated')({
    component: AuthenticatedLayout,
    beforeLoad: ({ context, location }) => {
        if (context.authentication?.status === 'unauthenticated') {
            throw redirect({ to: '/sign-in', search: { redirect: location.href } });
        }
    },
});
function AuthenticatedLayout() {
    const router = useRouter();
    const authentication = useAuthenticationState();
    const { theme, setTheme, palette, setPalette, animation, setAnimation } = useTheme();
    React.useEffect(() => {
        if (authentication.status === 'unauthenticated') {
            router.navigate({
                to: '/sign-in',
                search: { redirect: router.state.location.href },
                replace: true,
            });
        }
    }, [authentication.status, router]);
    // Apply the user's persisted theme on sign-in / re-load. Local state
    // (localStorage) is treated as a cache — backend wins. PreferencesCard
    // handles persisting subsequent changes.
    const userTheme = authentication.user?.theme;
    React.useEffect(() => {
        if (!userTheme)
            return;
        if (userTheme === theme)
            return;
        setTheme(userTheme);
    }, [userTheme, theme, setTheme]);
    const userPalette = authentication.user?.palette;
    React.useEffect(() => {
        if (!userPalette)
            return;
        if (userPalette === palette)
            return;
        setPalette(userPalette);
    }, [userPalette, palette, setPalette]);
    const userAnimation = authentication.user?.animation;
    React.useEffect(() => {
        if (!userAnimation)
            return;
        if (userAnimation === animation)
            return;
        setAnimation(userAnimation);
    }, [userAnimation, animation, setAnimation]);
    React.useEffect(() => {
        if (authentication.status === 'authenticated' &&
            authentication.user &&
            !authentication.user.onboardingCompleted &&
            !router.state.location.pathname.startsWith('/console/onboarding')) {
            router.navigate({ to: '/console/onboarding', replace: true });
        }
    }, [authentication.status, authentication.user, router]);
    if (authentication.status === 'loading')
        return null;
    return <Outlet />;
}
